var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('vue-tooltip',{attrs:{"displayText":_vm.withEndingDot ? (_vm.getHumanizeDate + ".") : _vm.getHumanizeDate,"text":_vm.getFullDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }